module.exports = __webpack_public_path__ + "img/Atilla.291e1bc7.png";